import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AlertsTable from '../components/tables/AlertsTable';
import { ButtonPrimary, ButtonSecondary } from '../components/Buttons';
import toast from 'react-hot-toast';

const AlertsPage = () => {
  const [alerts, setAlerts] = useState({});
  const { serial } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { sendAuthenticatedRequest } = useAuth();
  const message = searchParams.get('message');

  const isUrgent = serial === 'urgent';

  const loadAlerts = async () => {
  try {
    const url = isUrgent ? `/errors/urgent` : `/devices/${serial}/alerts`;
    const response = await sendAuthenticatedRequest(url, 'GET');
    setAlerts(response);
  } catch (error) {
    console.error(error);
    toast.error('Failed to load alerts');
  }
};


  const handleMarkReadUnread = async (_serial, alertId) => {
  try {
    const url = isUrgent
      ? `/errors/urgent/${alertId}/read`
      : `/devices/${serial}/alerts/${alertId}/read`;

    await sendAuthenticatedRequest(url, 'POST');
    loadAlerts();
  } catch (error) {
    console.error(error);
    toast.error('Failed to update alert status');
  }
};


  const handleMarkAllRead = async () => {
  try {
    const url = isUrgent
      ? `/errors/urgent/read-all`
      : `/devices/${serial}/alerts/read-all`;

    await sendAuthenticatedRequest(url, 'POST');
    loadAlerts();
    toast.success('All alerts marked as read!');
  } catch (error) {
    console.error(error);
    toast.error('Failed to mark all alerts as read');
  }
};


  useEffect(() => {
    loadAlerts();
  }, [serial]);

  return (
    <div className="p-6 space-y-6 bg-background min-h-screen">
      {message && (
        <div className="alert alert-primary" role="alert">
          <h1 className="text-xl font-bold">{message}</h1>
        </div>
      )}

      <div className="flex flex-row justify-between items-center">
        <h2 className="text-2xl font-bold">
  {isUrgent ? 'Global Urgent Alerts' : `Alerts for device ${serial}`}
</h2>

        <div className="flex space-x-2">
          <ButtonPrimary onClick={handleMarkAllRead}>
            Mark all read
          </ButtonPrimary>
          <ButtonSecondary onClick={() => navigate('/')}>
            Return Home
          </ButtonSecondary>
        </div>
      </div>

      <AlertsTable alerts={alerts} onMarkReadUnread={handleMarkReadUnread} />
    </div>
  );
};

export default AlertsPage;
